angular.module('shared').directive('linksWithTargetBlank', ["$timeout", function($timeout) {
  return {
    restrict: 'A',
    link: function(scope, element) {
      return $timeout(function() {
        return element.find('a').each(function(i, item) {
          return item.target = '_blank';
        });
      });
    }
  };
}]);
